import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './SearchMapGroupLabel.css';

class SearchMapGroupLabel extends Component {
    shouldComponentUpdate(nextProps) {
        const paletteAttribChanged = nextProps.palette !== this.props.palette;

        const hasSameAmountOfListings = nextProps.listings.length === this.props.listings.length;
        const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
        const hasSameRefreshToken =
            this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;

        return (
            paletteAttribChanged ||
            !(hasSameAmountOfListings && hasSameActiveStatus && hasSameRefreshToken)
        );
    }

    render() {
        const {
            className,
            rootClassName,
            listings,
            onListingClicked,
            isActive,
            isVisited,
            palette,
        } = this.props;
        const classes = classNames(rootClassName || css.root, className, {
            [css[palette]]: !!palette && css[palette],
        });
        const countLabelClasses = classNames(css.details, {
            [css.detailsActive]: isActive,
            [css.detailsVisited]: isVisited,
            [css.doubleDigit]: listings.length >= 10,
            [css.tripleDigit]: listings.length >= 100,
        });
        const caretClasses = classNames(css.caret, {
            [css.caretActive]: isActive,
            [css.caretVisited]: isVisited,
        });

        return (
            <button className={classes} onClick={() => onListingClicked(listings)}>
                <div className={css.caretShadow} />
                <div className={countLabelClasses}>{listings.length}</div>
                <div className={caretClasses} />
            </button>
        );
    }
}

const { arrayOf, func, string, any } = PropTypes;

SearchMapGroupLabel.propTypes = {
    className: string,
    rootClassName: string,
    listings: arrayOf(any).isRequired,
    onListingClicked: func.isRequired,
};

export default SearchMapGroupLabel;
